import { DefaultState, TableDataResponse } from 'features/types';
import { Paging, SelectItem, ObjectsSelectItem, ObjectsSelectListResponse, S3File } from 'api/types';
import { Tab } from 'api/types';
import { JobSeekerManagersForm, MemberProgramRolesSelect } from 'features/job-seeker-manage';
import { JobSeekerOtherProfileLinks } from 'features/job-seeker-profile';
import { JobSeekerCommunityAdminRole } from 'features/job-seeker-auth';

export type JobSeekersRequestData = {
  paging: Paging;
  filters: GetJobSeekersTableFilters
};

export type JobSeekersState = DefaultState & {
  requestData: JobSeekersRequestData;
  data: {
    tableDataIsLoading: boolean;
    tabsIsLoading: boolean;
    tableData: TableDataResponse<JobSeekerTableView>;
    tabs: Tab[];
  },
  addForm: JobSeekerFormData,
};

export type JobSeekerFormData = {
  id?: string;
  name?: string;
  nickName?: string;
  email?: string;
  tags?: string[];
  skills?: string[];
  programs?: SelectItem[];
  programsIds?: string[];
  managers?: JobSeekerManagersForm[];
  organizationAllProgramIds?: string[];
  memberCommunityAdminRolesSelectList?: SelectItem[];
  memberProgramRolesSelectList?: SelectItem[];
};

export type JobSeekerForm = {
  id?: string;
  name?: string;
  nickName?: string;
  email?: string;
  tags?: string[];
  skills?: string[];
  isVerified: boolean;
  communityAdminRole: JobSeekerCommunityAdminRole;
  programs?: SelectItem[];
  programsIds?: string[];
  leadProgramsIds?: string[];
  programRoles?: MemberProgramRolesSelect;
  managers?: JobSeekerManagersForm[];
  onBehalfOfOrganizationId?: string;
};

export type JobSeekerTableView = {
  id: string;
  name: string;
  nickName?: string;
  profileHeadline?: string;
  photo?: string;
  phone?: string | null;
  email: string;
  city?: string;
  state?: string;
  zipcode?: number;
  employmentStatus: string[];
  skills?: string[];
  experienceLevels?: string[];
  isVerified: boolean;
  lastLoginAt?: Date;
  programs: string[];
  isCommunityAdmin: boolean;
  leadPrograms: string[];
  managingOnBehalfOf?: string;
  otherProfileLinks?: JobSeekerOtherProfileLinks;
  profileIsPrivate?: boolean;
  profileIsPublicEmploymentStatuse?: boolean;
  profileIsPublicZipCode?: boolean;
  profileIsPublicEmailAddress?: boolean;
  profileIsPublicPhone?: boolean;
  profileIsPublicOneClickResume?: boolean;
  signUpCompleted: boolean;
  managerUsersNames?: string;
  joiningSource?: string;
  joiningSourceLink: string;
  addedByUserName?: string;
  invitedByName?: string;
};

export type GetJobSeekersTableFilters = {
  text?: string;
  managerId?: string;
  tab: string;
};

export type CheckEmail = {
  email: string;
};

export type SavedEmployerSelectListResponse = ObjectsSelectListResponse<S3File>;
export type EmployerSelectItem = ObjectsSelectItem<S3File>;

export enum JobSeekersTabs {
  All = 'All',
  Verified = 'Verified',
  NotVerified = 'NotVerified',
}
